import React from "react";
import CompanyAddOrUpdateContent from "../content/companyAddOrUpdateContent";
import Layout from "../layout/Layout";

const CompanyAddOrUpdate = () => {
  return (
    <Layout>
      <CompanyAddOrUpdateContent />
    </Layout>
  );
};

export default CompanyAddOrUpdate;
